import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import RegistrationShiftView from './registrationShiftView';
import useExternalSettings from '../../../../hooks/useExternalSettings';
import { Creators as getEnrollmentCoursesActions } from '@/domain/useCases/getEnrollmentCourses';
import { Creators as getProfileTurn } from '@/domain/useCases/getProfileTurn';
import { getHeaderInformation } from './constants';

const RegistrationShiftController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const hasTriedCourses = useRef(false);

  const { enrolmentPeriod, enrollmentPeriodName: periodDesc } =
    useExternalSettings();
  const { data: academicData = {}, isLoading: isLoadingAcademic } = useSelector(
    (state: any) => state.profile
  );
  const { data: coursesData = [], isLoading: isLoadingCourses } = useSelector(
    (state: any) => state?.EnrolmentCourses
  );
  const { data: turn = {}, isLoading: isLoadingTurn } = useSelector(
    (state: any) => state.profileTurn
  );

  const { enrolmentAppointment = {} } = turn ?? {};
  const { textDate = '', textHour = '' } = enrolmentAppointment ?? {};
  const timeDay = {
    textDate: textDate ?? '',
    textHour: textHour ?? ''
  };

  const { academic = {} } = academicData ?? {};

  const courses = Array.isArray(coursesData) ? coursesData : [];
  const formattedType = (type: string) => {
    switch (type) {
      case 'O':
        return 'Obligatorio';
      case 'E':
        return 'Electivos';
      default:
        return '';
    }
  };
  const formattedCourses = courses.length
    ? courses
        .slice()
        .sort((a: any, b: any) => a.cicle - b.cicle)
        .map((course: any) => ({
          ...course,
          hours: Number.isInteger(course.hours)
            ? course.hours
            : course.hours.toFixed(2),
          credits: Number.isInteger(course.credits)
            ? course.credits
            : course.credits.toFixed(2),
          cicle: Math.floor(course.cicle),
          type: formattedType(course.type)
        }))
    : [];

  useEffect(() => {
    if (
      !isLoadingTurn &&
      (turn == null ||
        (typeof turn === 'object' && Object.keys(turn).length === 0))
    ) {
      dispatch(getProfileTurn.getProfileTurn(enrolmentPeriod));
    }

    if (
      !isLoadingCourses &&
      courses.length === 0 &&
      academic?.campus &&
      academic?.career &&
      academic?.plan &&
      academic?.prog &&
      !hasTriedCourses.current
    ) {
      hasTriedCourses.current = true;
      dispatch(
        getEnrollmentCoursesActions.getEnrollmentCourses(
          academic.campus,
          academic.career,
          academic.plan,
          academic.prog,
          enrolmentPeriod
        )
      );
    }
  }, [
    isLoadingTurn,
    isLoadingCourses,
    turn,
    courses.length,
    academic?.campus,
    academic?.career,
    academic?.plan,
    academic?.prog,
    enrolmentPeriod,
    dispatch
  ]);

  const headerInformation = getHeaderInformation(periodDesc);

  const onBack = () => history.goBack();

  return (
    <RegistrationShiftView
      courses={formattedCourses}
      isLoading={{
        isLoadingAcademic,
        isLoadingTurn,
        isLoadingCourses
      }}
      onBack={onBack}
      enrollmentTurn={{
        ...timeDay,
        periodDesc
      }}
      headerInformation={headerInformation}
    />
  );
};

export default RegistrationShiftController;
